"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Console_1 = require("./Console");
exports.default = Console_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Console/index.js
// module id = 920
// module chunks = 8